import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const successToast = (message = "sucess") => {
  return toast.success(message, {
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

export default successToast;
